import { COLOR1, COLOR2, ORIENTAL_ORANGE } from '../../../constants';

export const PersonalInformationStyles = {
  personal_info_stepper: {
    width: '100%',
    margin: '37px 30px 40px 50px',
    '@media (max-width:650px)': {
      margin: '37px 50px 45px 50px',
    },
    '@media (max-width:650px)': {
      margin: '25px',
    },
  },
  idUploadPosition: {
    paddingLeft: '30px',
    '@media (max-width:600px)': {
      paddingLeft: 0,
      marginBottom: '20px',
    },
  },

  inputs_grid_margin: {
    '@media (max-width:600px)': {
      padding: '2px',
    },
  },

  personal_info_grid_margin: {
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
    borderRadius: '6px',
    '@media (max-width:599px)': {
      border: 'none',
      boxShadow: 'none',
      borderRadius: 0,
      padding: 0,
      marginTop: '-30px',
    },
  },

  idDescriptionTwo: {
    font: 'normal normal normal 16px/17px Arial',
    color: ORIENTAL_ORANGE,
    marginTop: '30px',

    '@media (max-width:960px)': {
      marginTop: '15px',
      font: 'normal normal normal 14px/16px Arial',
    },
  },
  form_heading_info: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal normal 20px/23px Arial',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:650px)': {
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      margin: '0',
      marginBottom: '5px',
    },
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  middleName: {
    width: '100%',
    '@media (max-width:960px)': {
      width: '100%',
    },
  },

  personal_heading_info: {
    marginBottom: '25px',
    font: 'normal normal bold 20px/23px Arial',
    '@media (max-width:960px)': {
      marginTop: '0',
      marginBottom: '25px',
    },
    '@media (max-width:960px)': {
      font: 'normal normal 700 22px/32px Arial',
    },
    '@media (max-width:600px)': {
      font: 'normal normal 700 22px/32px Arial',
      marginBottom: 0,
    },
  },

  mar_top_adj: {
    '@media (max-width:960px)': {
      marginTop: 0,
    },
  },

  mar_top_adj_idDescriptionWrapper: {
    '@media (max-width:960px)': {
      marginTop: 0,
    },
  },

  personal_button_container: {
    '@media (max-width:650px)': {
      justifyContent: 'center',
      display: 'flex',
    },
  },

  fieldSpaceCommon: {
    '&.MuiGrid-spacing-xs-3 > .MuiGrid-item': {
      padding: '12px',
    },
  },
};
